<template>
  <StatIcon :color-index="colorIndexForType('group')">
    <template #statNumber>
      {{ formattedMembersCount }}
    </template>
    <template #statUnits>
      {{ i18n.t('activerecord.models.member', {count: membersCount}) }}
    </template>
  </StatIcon>
</template>

<script>
import StatIcon from '../components/stat-icon'
export default {
  components: { StatIcon },

  props: {
    membersCount: {
      type: Number,
      required: true
    }
  },

  computed: {
    formattedMembersCount() {
      // Abbreviate number for display, e.g., turn 10000 into "10K".
      if (this.membersCount >= 1000) {
        // k is a SI unit abbreviation, so lets assume we do not need to internationalize it. This has the huge
        // advantage of not needing an external library for number formating beyond i18n-js. We're fine with the other
        // trade offs in formatting.
        const thousands = this.membersCount/1000
        const rounded = Math.round( thousands * 10 ) / 10
        return `${rounded}k`
      } else {
        return this.i18n.toNumber(this.membersCount, {precision: 0})
      }
    }
  }
}
</script>
